<template>
  <UiContainer class="delivery-view" :max-width="1100">
    <h1 class="delivery-view__title">Информация о поставках</h1>
    <p class="delivery-view__lead">
      ЛабАктив развивает B2B-платформу для поиска поставщиков. На текущем этапе сервис не является
      продавцом, перевозчиком или платёжным агентом.
    </p>

    <div class="delivery-view__grid">
      <UiCard class="delivery-view__card">
        <h2 class="delivery-view__card-title">Поставка</h2>
        <ul class="delivery-view__list">
          <li>Способ, стоимость и срок поставки определяет поставщик для конкретного заказа.</li>
          <li>Возможность доставки или самовывоза подтверждается до заключения сделки.</li>
          <li>Условия поставки фиксируются в договорённостях сторон.</li>
        </ul>
        <p class="delivery-view__note">
          Информация в карточке товара носит ознакомительный характер и может быть уточнена
          поставщиком.
        </p>
      </UiCard>

      <UiCard class="delivery-view__card">
        <h2 class="delivery-view__card-title">Расчёты</h2>
        <ul class="delivery-view__list">
          <li>Условия оплаты согласуются покупателем и поставщиком отдельно.</li>
          <li>ЛабАктив не принимает платежи и не выпускает расчётные документы по сделкам.</li>
          <li>До запуска коммерческой модели оплата через платформу недоступна.</li>
        </ul>
        <p class="delivery-view__note">
          Перед оплатой необходимо получить от поставщика подтверждённые условия сделки.
        </p>
      </UiCard>
    </div>

    <UiCard class="delivery-view__card delivery-view__card--full">
      <h2 class="delivery-view__card-title">Гарантии и возвраты</h2>
      <ul class="delivery-view__list">
        <li>Гарантийные обязательства определяются поставщиком или производителем.</li>
        <li>Порядок приёмки и возврата определяется условиями конкретной сделки.</li>
        <li>Права и обязанности сторон регулируются договором и применимым законодательством.</li>
      </ul>
    </UiCard>
  </UiContainer>
</template>

<script setup lang="ts">
import UiCard from '@/shared/ui/UiCard.vue'
import UiContainer from '@/shared/ui/UiContainer.vue'
</script>

<style scoped>
.delivery-view {
  padding-top: 40px;
  padding-bottom: 64px;
}

.delivery-view__title {
  margin: 0 0 16px;
  font-size: 28px;
  font-weight: 700;
}

.delivery-view__lead {
  margin: 0 0 32px;
  font-size: 16px;
  color: #475569;
  line-height: 1.6;
}

.delivery-view__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 32px;
}

@media (max-width: 960px) {
  .delivery-view__grid {
    grid-template-columns: minmax(0, 1fr);
  }
}

.delivery-view__card {
  padding: 24px;
}

.delivery-view__card-title {
  margin: 0 0 16px;
  font-size: 16px;
  font-weight: 600;
}

.delivery-view__list {
  margin: 0 0 16px;
  padding-left: 1.25rem;
}

.delivery-view__list li {
  margin-bottom: 8px;
  line-height: 1.5;
}

.delivery-view__note {
  margin: 0;
  font-size: 13px;
  color: #586578;
}
</style>
